// GENERATED by tools/generate-maplibre-env.js — do not edit, do not commit.
export const STADIA_MAPS_API_KEY = '66782e54-5d25-461e-a766-a5664aeb9518';
